import { Fragment, useEffect, useState } from "react";
import "./user_analytics_content_component.scss";
import { isEmpty } from "../../../../custom_utilities/custom_useful_functions";
import axios from "axios";
import {
  url_9,
  url_41,
  url_42,
  url_296,
  url_297,
} from "../../../../custom_utilities/api_services";
import moment from "moment";
import { connect } from "react-redux";
import uiActions from "../../../../redux/ui/action";
import userTestsExercisesAction from "../../../../redux/user_tests_exercises/action";
import {
  pickPaperName,
  setPaperId,
  setPaperName,
} from "../../../../parent/redux/testDataSlice/TestDataSlice";
import {
  setUserId,
  setLoginFromParentFlag,
  setParentTarget,
} from "../../../../parent/redux/authSlice/AuthSlice";
import images from "../../../../utilities/images/images";

const FOUNDATION_TARGETS_HIDE_OVERALL = [10, 11];

const extractOverallPerformanceRows = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  const candidateKeys = [
    "OverallPerformanceReport",
    "overallPerformanceReport",
    "performance_list",
    "tests",
    "rows",
    "report",
    "test_list",
    "overall_performance",
    "list",
  ];
  for (const key of candidateKeys) {
    const v = payload[key];
    if (Array.isArray(v) && v.length > 0) return v;
  }
  for (const key of candidateKeys) {
    const v = payload[key];
    if (Array.isArray(v)) return v;
  }
  return [];
};

const pickNum = (row, keys) => {
  for (const k of keys) {
    if (row[k] === undefined || row[k] === null || row[k] === "") continue;
    const n = Number(row[k]);
    if (!Number.isNaN(n)) return n;
  }
  return null;
};

const mapPerformanceRow = (raw, index) => {
  const paper_id =
    raw.paper_id ??
    raw.paperId ??
    raw.test_id ??
    raw.paperid ??
    raw.paperID;
  const testName =
    raw.test_name ??
    raw.paper_name ??
    raw.test_format ??
    raw.name ??
    raw.title ??
    raw.format_name ??
    `Test ${index + 1}`;
  const tm = pickNum(raw, ["tm", "total_marks", "TM", "total_mark", "marks"]);
  const p = pickNum(raw, [
    "Physics",
    "physics",
    "p",
    "physics_marks",
    "P",
    "phy_marks",
  ]);
  const c = pickNum(raw, [
    "Chemistry",
    "chemistry",
    "c",
    "chemistry_marks",
    "C",
    "chem_marks",
  ]);
  const m = pickNum(raw, [
    "Maths",
    "maths",
    "Mathematics",
    "mathematics",
    "maths_marks",
    "m",
    "M",
    "math_marks",
  ]);
  const raRaw = raw.rank ?? raw.ra ?? raw.Ra ?? raw.predicted_rank;
  const rankDisplay =
    raRaw === undefined || raRaw === null || raRaw === "" ? "-" : String(raRaw);
  const rank =
    raRaw === undefined || raRaw === null || raRaw === "" || raRaw === "-"
      ? null
      : Number(raRaw);

  const nestedTestWise =
    raw.testWiseData ?? raw.test_wise_data ?? raw.TestWiseData;
  const testWiseData =
    nestedTestWise && typeof nestedTestWise === "object"
      ? nestedTestWise
      : {
          user_id: raw.user_id,
          paper_id:
            raw.paper_id ??
            raw.paperId ??
            raw.test_id ??
            raw.paperid ??
            raw.paperID,
        };

  const curt_paper = String(
    raw.curt_paper ??
      raw.curtPaper ??
      testWiseData?.paper ??
      testWiseData?.paper_name ??
      raw.paper ??
      testName
  ).replace(/\s/g, "");

  return {
    paper_id,
    testName,
    tm,
    p,
    c,
    m,
    rankDisplay,
    rank: Number.isFinite(rank) ? rank : null,
    testWiseData,
    curt_paper,
    view_sol_time:
      raw.view_sol_time !== undefined ? Boolean(raw.view_sol_time) : true,
    view_solution: raw.view_solution ?? raw.view_solution_time ?? "",
    raw,
  };
};

const formatPerformanceCell = (value) => {
  if (value === null || value === undefined) return "—";
  return String(value);
};

const UserAnalyticsContentComponent = (props) => {
  let {
    history,
    userPreference,
    startLoading,
    finishLoading,
    userId,
    setUserId,
    setPaperId,
    setPaperName,
    setLoginFromParentFlag,
    setParentTarget,
    target,
    targetId,
    embeddedInMySpace,
  } = props;

  const resolvedTargetId = Number(
    targetId ?? userPreference?.targetDetails?.[0]?.target_id
  );
  const hideOverallTestTab =
    FOUNDATION_TARGETS_HIDE_OVERALL.includes(resolvedTargetId);

  const [state, setState] = useState({
    tabType: 1, // Default tabType
    overallPerformanceRows: [],
    individualTestSubjectDataDetails: {
      subjectId: "",
      subjectName: "",
      subjectIcon: "",
    },
    individualTestSubjectList: {},
    individualTestList: {},
    individualTestInitialSubjectCheck: true,
    individualTestListPageNumber: 1,
    learnAnalysisSubjectDataDetails: {
      subjectId: "",
      subjectName: "",
      subjectIcon: "",
    },
    learnAnalysisSubjectList: {},
    learnAnalysisData: {},
    learnAnalysisInitialSubjectCheck: true,
  });

  // Schoolympiad / foundation targets (10, 11): only Individual Test. Otherwise honor dashboard link tab hint.
  useEffect(() => {
    if (hideOverallTestTab) {
      setState((prevState) => ({
        ...prevState,
        tabType: 2,
        individualTestInitialSubjectCheck: true,
      }));
      sessionStorage.removeItem("activeTab");
      return;
    }

    const activeTab = sessionStorage.getItem("activeTab");
    if (activeTab === "individual_test") {
      setState((prevState) => ({
        ...prevState,
        tabType: 2,
        individualTestInitialSubjectCheck: true,
      }));
      sessionStorage.removeItem("activeTab");
    }
  }, [hideOverallTestTab]);

  useEffect(() => {
    if (state.tabType === 1) {
      if (!hideOverallTestTab) {
        getOverAllTestsData();
      }
    } else if (state.tabType === 2) {
      getIndividualTestSubjectList();
    } else if (state.tabType === 3) {
      getLearnAnalysisSubjectList();
    }
  }, [state.tabType, hideOverallTestTab]);

  useEffect(() => {
    if (
      state.tabType === 2 &&
      !isEmpty(state.individualTestSubjectList) &&
      state.individualTestSubjectList.subject.length &&
      state.individualTestInitialSubjectCheck
    ) {
      getIndividualTestInitialData();
    }
  }, [state.tabType, state.individualTestSubjectList]);

  useEffect(() => {
    if (
      state.tabType === 3 &&
      !isEmpty(state.learnAnalysisSubjectList) &&
      state.learnAnalysisSubjectList.subject.length &&
      state.learnAnalysisInitialSubjectCheck
    ) {
      getLearnAnalysisInitialData();
    }
  }, [state.tabType, state.learnAnalysisSubjectList]);

  const getIndividualTestInitialData = () => {
    let { subject } = state.individualTestSubjectList;

    setState((prevState) => ({
      ...prevState,
      individualTestSubjectDataDetails: {
        ...prevState.individualTestSubjectDataDetails,
        subjectId: subject?.[0]?.sub_id,
        subjectName: subject?.[0]?.sub_name,
        subjectIcon: subject?.[0]?.icon,
      },
      individualTestInitialSubjectCheck: false,
    }));

    getIndividualTestList(subject?.[0]?.sub_id);
  };

  const getLearnAnalysisInitialData = () => {
    let { subject } = state.learnAnalysisSubjectList;

    setState((prevState) => ({
      ...prevState,
      learnAnalysisSubjectDataDetails: {
        ...prevState.learnAnalysisSubjectDataDetails,
        subjectId: subject?.[0]?.sub_id,
        subjectName: subject?.[0]?.sub_name,
        subjectIcon: subject?.[0]?.icon,
      },
      learnAnalysisInitialSubjectCheck: false,
    }));

    getLearnAnalysisData(subject?.[0]?.sub_id);
  };

  const getOverAllTestsData = async () => {
    startLoading();
    try {
      const response = await axios.get(url_297);
      if (response.data.status === 200) {
        const list = extractOverallPerformanceRows(response?.data?.data);
        const overallPerformanceRows = list.map(mapPerformanceRow);
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          overallPerformanceRows,
        }));
      } else {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          overallPerformanceRows: [],
        }));
      }
    } catch (error) {
      finishLoading();
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        overallPerformanceRows: [],
      }));
    }
  };

  const getIndividualTestSubjectList = async () => {
    let requestPayload = {
      course_id: userPreference?.courseDetails?.[0]?.course_id,
      class_id: userPreference?.classDetails?.class_id,
    };
    startLoading();
    try {
      const response = await axios.post(url_9, requestPayload);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          individualTestSubjectList: response.data.data,
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const handleTabChange = (tabType) => {
    switch (tabType) {
      case "overall_tests":
        setState((prevState) => ({
          ...prevState,
          tabType: 1,
          individualTestInitialSubjectCheck: true,
        }));
        break;
      case "individual_test":
        setState((prevState) => ({
          ...prevState,
          tabType: 2,
          individualTestInitialSubjectCheck: true,
        }));
        break;
      case "learn_analysis":
        setState((prevState) => ({
          ...prevState,
          tabType: 3,
          individualTestInitialSubjectCheck: true,
        }));
        break;
      default:
        break;
    }
  };

  const getIndividualTestList = async (subject_id) => {
    startLoading();
    try {
      const response = await axios.get(url_41);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          individualTestList: response.data.data,
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const openFoundationTestReportPdf = async (paper_id) => {
    startLoading();
    try {
      const response = await axios.get(url_296, {
        params: { paper_id, user_id: userId },
      });
      const payload = response.data;
      finishLoading();

      const pdfUrl = payload?.data?.pdf_url;
      if (payload?.status === 200 && pdfUrl) {
        window.open(pdfUrl, "_blank", "noopener,noreferrer");
        return;
      }

      const msg = payload?.message;
      if (typeof msg === "string" && msg && msg !== "Success") {
        alert(msg);
      } else {
        alert("Could not load report.");
      }
    } catch (error) {
      finishLoading();
      console.log(error);
      alert("Could not open report. Please try again.");
    }
  };

  const handleRedirectToParent = async (testData) => {
    if (!testData.view_sol_time) {
      alert(`Solutions will be shown after ${testData.view_solution}`);
      return;
    }

    if (hideOverallTestTab) {
      await openFoundationTestReportPdf(testData.paper_id);
      return;
    }

    await setParentTarget(target);
    setPaperId(testData.paper_id);
    const paperName = pickPaperName(testData);
    if (paperName) setPaperName(paperName);
    setUserId(userId);
    setLoginFromParentFlag(false);

    history.push({
      pathname: "/student-tests",
      state: {
        step: 2,
        paper_name: paperName,
      },
    });
  };

  const openStudentTestPageFromOverallRow = (row) => {
    const testWiseData = row.testWiseData;
    const paperId = testWiseData?.paper_id ?? row.paper_id;

    if (paperId == null || paperId === "") {
      alert("Missing test identifier for this report.");
      return;
    }

    handleRedirectToParent({
      paper_id: paperId,
      paper_name: row.testName || pickPaperName(row.raw) || pickPaperName(testWiseData),
      view_sol_time: row.view_sol_time,
      view_solution: row.view_solution,
    });
  };

  const getLearnAnalysisSubjectList = async () => {
    let requestPayload = {
      course_id: userPreference.courseDetails[0].course_id,
      class_id: userPreference.classDetails.class_id,
    };
    startLoading();
    try {
      const response = await axios.post(url_9, requestPayload);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          learnAnalysisSubjectList: response.data.data,
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const getLearnAnalysisData = async (subject_id) => {
    startLoading();
    try {
      const response = await axios.get(`${url_42}?subject_id=${subject_id}`);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          learnAnalysisData: response.data.data,
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  return (
    <Fragment>
      <div
        className={`userAnalyticsContentComponent_wrapper${
          embeddedInMySpace ? " userAnalyticsContentComponent_wrapper--my-space" : ""
        }`}
      >
        <div className="container-fluid container-lg">
          <div className="userAnalyticsContentComponent_inner_wrapper">
            <div className="section_wrapper">
              <div className="section_inner_wrapper">
                <div className="user_analytics_page_header">
                  {!embeddedInMySpace ? (
                    <button
                      type="button"
                      className="user_analytics_back_btn"
                      aria-label="Back to dashboard"
                      onClick={() => history.push("/dashboard")}
                    >
                      <img src={images.new_backarrow} alt="" />
                    </button>
                  ) : (
                    <span className="user_analytics_back_spacer" aria-hidden />
                  )}
                  <h2>Test Analytics</h2>
                  <span className="user_analytics_back_spacer" aria-hidden />
                </div>
                <div className="options_wrapper">
                  <ul
                    className="nav nav-pills custom_nav_pills"
                    id="pills-tab"
                    role="tablist"
                  >
                    {!hideOverallTestTab ? (
                      <li
                        className="nav-item custom_nav_item"
                        role="presentation"
                      >
                        <button
                          className={`nav-link ${
                            state.tabType === 1 ? "active" : ""
                          } custom_nav_link`}
                          id="pills-overall-test-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-overall-test"
                          type="button"
                          role="tab"
                          aria-controls="pills-overall-test"
                          aria-selected={state.tabType === 1}
                          onClick={() => handleTabChange("overall_tests")}
                        >
                          Overall Test
                        </button>
                      </li>
                    ) : null}
                    <li
                      className="nav-item custom_nav_item"
                      role="presentation"
                    >
                      <button
                        className={`nav-link ${
                          state.tabType === 2 ? "active" : ""
                        } custom_nav_link`}
                        id="pills-individual-test-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-individual-test"
                        type="button"
                        role="tab"
                        aria-controls="pills-individual-test"
                        aria-selected={state.tabType === 2}
                        onClick={() => handleTabChange("individual_test")}
                      >
                        Individual Test
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="tab_wrapper">
                  <div
                    className="tab-content custom_tab_content"
                    id="pills-tabContent"
                  >
                    {/* Overall Test Tab */}
                    {!hideOverallTestTab ? (
                      <div
                        className={`tab-pane fade ${
                          state.tabType === 1 ? "show active" : ""
                        } custom_tab_pane`}
                        id="pills-overall-test"
                        role="tabpanel"
                        aria-labelledby="pills-overall-test-tab"
                      >
                        <div className="overall_test_tab_wrapper">
                          <div className="overall_performance_table_card">
                            <div className="overall_performance_table_scroll">
                              <table className="overall_performance_table">
                                <thead>
                                  <tr>
                                    <th>Test format</th>
                                    <th>TM</th>
                                    <th>P</th>
                                    <th>C</th>
                                    <th>M</th>
                                    <th>Ra</th>
                                    <th>VA</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {state.overallPerformanceRows.length ? (
                                    state.overallPerformanceRows.map(
                                      (row, idx) => (
                                        <tr
                                          key={`${row.paper_id ?? "r"}-${idx}`}
                                        >
                                          <td className="overall_performance_test_cell">
                                            <span className="overall_performance_test_name">
                                              {row.testName}
                                            </span>
                                          </td>
                                          <td>
                                            {formatPerformanceCell(row.tm)}
                                          </td>
                                          <td>
                                            {formatPerformanceCell(row.p)}
                                          </td>
                                          <td>
                                            {formatPerformanceCell(row.c)}
                                          </td>
                                          <td>
                                            {formatPerformanceCell(row.m)}
                                          </td>
                                          <td>{row.rankDisplay}</td>
                                          <td className="overall_performance_va_cell">
                                            {row.paper_id != null ? (
                                              <button
                                                type="button"
                                                className="overall_performance_va_btn"
                                                aria-label="View analysis"
                                                onClick={() =>
                                                  openStudentTestPageFromOverallRow(
                                                    row
                                                  )
                                                }
                                              >
                                                <img
                                                  src={images.eyeView}
                                                  alt=""
                                                />
                                              </button>
                                            ) : (
                                              "—"
                                            )}
                                          </td>
                                        </tr>
                                      )
                                    )
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={7}
                                        className="overall_performance_empty"
                                      >
                                        No test performance data yet.
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {/* Individual Test Tab */}
                    <div
                      className={`tab-pane fade ${
                        state.tabType === 2 ? "show active" : ""
                      } custom_tab_pane`}
                      id="pills-individual-test"
                      role="tabpanel"
                      aria-labelledby="pills-individual-test-tab"
                    >
                      <div className="individual_test_tab_wrapper">
                        <div className="outer_content_wrapper">
                          <div className="right_side_content_wrapper">
                            <div className="tests_collection_wrapper">
                              {!isEmpty(state.individualTestList)
                                ? state.individualTestList.TestList?.data
                                    ?.length
                                  ? state.individualTestList.TestList.data.map(
                                      (element, index) => (
                                        <div
                                          key={index}
                                          className="single_test_wrapper"
                                        >
                                          <div className="sub_section_wrapper_1">
                                            <label>{`Start at ${moment(
                                              element.start_date
                                            ).format("MMMM Do YYYY")}`}</label>
                                            <div className="paper_idd">
                                              <span className="paper_id_text">
                                                Paper ID:{" "}
                                              </span>
                                              {element.paper_id}
                                            </div>
                                          </div>
                                          <div className="sub_section_wrapper_2">
                                            <div className="text_content_wrapper">
                                              <p className="text_content">
                                                {element.paper_name}
                                              </p>
                                            </div>
                                          </div>
                                          <div>
                                            <p>
                                              Attempted on-{" "}
                                              {element.attempted_on}
                                            </p>
                                          </div>
                                          <div className="sub_section_wrapper_3">
                                            <div className="sub_content_wrapper">
                                              <div className="left_content_wrapper">
                                                <label>{`${element.total_questions} ques | ${element.duration_mins}min | ${element.total_marks} marks`}</label>
                                              </div>
                                              <div className="right_content_wrapper">
                                                <label
                                                  className="lbl_1"
                                                  onClick={() =>
                                                    handleRedirectToParent(
                                                      element
                                                    )
                                                  }
                                                >
                                                  {hideOverallTestTab
                                                    ? "View report"
                                                    : "View solution"}
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    )
                                  : null
                                : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    token: state.auth.authToken,
    tokenType: state.auth.tokenType,
    userId: state.auth.user.user_id,
    target: state?.auth?.user?.UsertargetDetail[0]?.target,
    targetId: state?.auth?.user?.UsertargetDetail?.[0]?.target_id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setUserTestsResultData: (payload) => {
      dispatch(userTestsExercisesAction.setUserTestsResultData(payload));
    },
    setPaperId: (payload) => {
      dispatch(setPaperId(payload));
    },
    setPaperName: (payload) => {
      dispatch(setPaperName(payload));
    },
    setUserId: (payload) => {
      dispatch(setUserId(payload));
    },
    setLoginFromParentFlag: (payload) => {
      dispatch(setLoginFromParentFlag(payload));
    },
    setParentTarget: (payload) => {
      dispatch(setParentTarget(payload));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAnalyticsContentComponent);
